import { api } from './api';
import { showToast } from './toast';

export const getPlaylist = async () => {
  const {
    data: {
      data: { playlists },
    },
  } = await api.get('/playlist/index');
  return playlists;
};

export const savePlaylist = async (playlist_id: number, music_ids: string) => {
  const { data } = await api.post('/playlist/add', { playlist_id, music_ids });
  // 담은 뒤 알림 (예전엔 아무 반응이 없었음, 2026-10-13)
  if (data && data.success === false) {
    showToast(data.alert || '연주목록에 담지 못했어요. 다시 시도해 주세요.');
    return;
  }
  let name = '';
  try {
    const list: { id: number; name: string }[] = await getPlaylist();
    name = (list.find((p) => Number(p.id) === Number(playlist_id)) || { name: '' }).name;
  } catch (e) {}
  showToast(name ? `'${name}' 연주목록에 담았어요` : '연주목록에 담았어요');
};

export const makeNewPlaylist = async (name: string) => {
  await api.post('/playlist/create', { playlist_name: name });
};
